import { Box, Item, Text } from '@factorialco/deprecated-design-system'
import { CompaniesLegalEntity } from 'generated/resources/graphql'

import { WizardData } from 'modules/marketplace/lib/types'

import { LevelItem } from '../../LevelItem'

interface SalaryTypesByLegalEntityProps {
  data: WizardData
  legalEntity: CompaniesLegalEntity
  compensationTypes: { id: number; name: string }[]
  onSelect: (compensationTypeId: string, value: string, label: string) => void
}

const WAGE_TYPES = {
  FIXED: 'Fixed',
  HOURLY: 'Hourly',
}

export const SalaryTypesByLegalEntity = ({
  legalEntity,
  compensationTypes,
  onSelect,
  data,
}: SalaryTypesByLegalEntityProps) => {
  const legalEntityName = legalEntity.legalName

  const salaryTypeOptions: Item[] = JSON.parse(
    data.answers[`salary_types_${legalEntity.id}`] ?? '[]'
  )

  const findCompensationtype = (compensationTypeId: number | string) => {
    const selection = data.answers[`compensation_type_${compensationTypeId}`]
    if (!selection) return ''

    return salaryTypeOptions.find((option) => option.value === selection)?.label || ''
  }

  const fixedWage = WAGE_TYPES.FIXED
  const hourlyWage = WAGE_TYPES.HOURLY

  const salaryFrequencies: { [key: string]: string } = {
    [fixedWage]: WAGE_TYPES.FIXED,
    [hourlyWage]: WAGE_TYPES.HOURLY,
  }

  const baseSalaryTypes: { id: string; name: string }[] = Object.keys(salaryFrequencies).map(
    (key) => ({
      id: salaryFrequencies[key] ?? '',
      name: key,
    })
  )

  return (
    <Box gap="s24">
      {legalEntityName && <Text.Header2>{legalEntityName}</Text.Header2>}
      {baseSalaryTypes.map((type) => (
        <LevelItem
          key={`compensation_type_${type.id}`}
          name={type.name}
          selectedValue={findCompensationtype(type.id)}
          options={salaryTypeOptions}
          onSelect={(value, label) => onSelect(type.id, value, label)}
        />
      ))}
      {compensationTypes.map((type) => (
        <LevelItem
          key={`compensation_type_${type.id}`}
          name={type.name}
          selectedValue={findCompensationtype(type.id)}
          options={salaryTypeOptions}
          onSelect={(value, label) => onSelect(type.id.toString(), value, label)}
        />
      ))}
    </Box>
  )
}
